import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import { Redirect } from 'react-router';

import RouteWithLayout from './RouteWithLayout';
import Home from 'containers/Home/Home';
import Transparency from 'containers/Transparency/Transparency';
import Reporting from 'containers/Reporting/Reporting';
import ReportingDownload from 'containers/ReportingDownload/ReportingDownload';
import Login from 'containers/Login';
import RestorePassword from 'containers/RestorePassword/RestorePassword';
import DataViewing from 'containers/DataViewing/DataViewing';
import Register from 'containers/Register/Register';
import FeedRegister from 'containers/Register/FeedRegister';
import DataSelect from 'containers/DataSelect';
import Documentation from 'containers/Documentation/Documentation';
import { UserDetails, ChangePassword, Subscriptions } from 'containers/MyAccount';
import { TermsOfUse, UnderConstruction } from 'containers/Help';

import paths from '../common/constants/paths';
import { withAuth } from 'src/common/auth/Auth';

class ShellRouter extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout secure={false} path={paths.home} pageId="home" navigationPage={Home} exact />
        <RouteWithLayout secure={false} path={paths.transparencyData} pageId="transparency" navigationPage={Transparency} exact />
        <RouteWithLayout secure={false} path={paths.reportingDownload} pageId="executionReportingDownload" navigationPage={ReportingDownload}  />
        <RouteWithLayout secure={false} path={paths.reporting} pageId="executionReporting" navigationPage={Reporting}  />
        <RouteWithLayout secure={false} path={paths.documentationLoad} pageId="documentation" navigationPage={Documentation}  />
        <RouteWithLayout secure={false} path="/login" pageId="login" navigationPage={Login} />
        <RouteWithLayout secure={false} path="/register" pageId="register" navigationPage={Register} />
        <RouteWithLayout secure={false} path="/slice-register" pageId="sliceRegister" navigationPage={Register} />
        <RouteWithLayout secure={false} path="/feed-register" pageId="feedRegister" navigationPage={FeedRegister} />
        <RouteWithLayout
          secure={false}
          path="/restore-password/:token?"
          pageId="restorePassword"
          navigationPage={RestorePassword}
        />

        <RouteWithLayout secure={false} path="/help/terms-of-use" pageId="termsOfUse" navigationPage={TermsOfUse} />

        <RouteWithLayout
          secure={false}
          path="/help/under-construction"
          pageId="underConstruction"
          navigationPage={UnderConstruction}
        />

        <RouteWithLayout
          area="dataViewing"
          secure={true}
          path="/data-viewing/order"
          pageId="orderDataViewing"
          navigationPage={DataViewing}
        />

        <RouteWithLayout
          area="dataViewing"
          secure={true}
          path="/data-viewing/trade"
          pageId="tradeDataViewing"
          navigationPage={DataViewing}
        />

        <RouteWithLayout
          area="dataViewing"
          secure={true}
          path="/data-viewing/:dataType?"
          pageId="dataViewing"
          navigationPage={DataViewing}
        />

        <RouteWithLayout
          secure={true}
          area="dataViewing"
          path={paths.dataSelect}
          pageId="dataSelect"
          navigationPage={DataSelect}
        />

        <RouteWithLayout
          secure={true}
          area="myAccount"
          path="/my-account/details"
          pageId="details"
          navigationPage={UserDetails}
        />

        <RouteWithLayout
          area="myAccount"
          secure={true}
          path="/my-account/subscriptions"
          pageId="subscriptions"
          navigationPage={Subscriptions}
        />
        <RouteWithLayout
          area="myAccount"
          secure={true}
          path="/my-account/change-password"
          pageId="changePassword"
          navigationPage={ChangePassword}
        />

        <RouteWithLayout
          area="myAccount"
          secure={true}
          path="/my-account"
          pageId="myAccount"
          navigationPage={UserDetails}
        />

        <Redirect from="/" to={paths.home} />
      </Switch>
    );
  }
}

export default withAuth(ShellRouter);



// WEBPACK FOOTER //
// ./src/routes/ShellRouter.jsx